export default "__VITE_ASSET__B4hI9Zo0__"